export class Funcionario {
  id: string;
  nome: string;
  descricao: string;
}